import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LAST_ACTIVE_TIME,
  MAX_ENABLE_INACTIVE_LOGOUT,
} from '../constants/system.keys';
import { authLogoutThunk } from '../redux/actions';
import { resetDataToken } from '../redux/socket';

export const useInActiveLogout = () => {
  const dispatch = useDispatch();
  const { dataUser } = useSelector((state) => state);

  const maxEnableInactiveLogoutTime = localStorage.getItem(
    MAX_ENABLE_INACTIVE_LOGOUT,
  );

  useEffect(() => {
    if (
      dataUser &&
      dataUser?.role &&
      dataUser?.role?.toLowerCase() === 'monitor'
    ) {
      return;
    }
    function handleSaveLastActive(event) {
      localStorage.setItem(
        LAST_ACTIVE_TIME,
        Math.floor(new Date().getTime() / 1000),
      );
    }
    // Bind the event listener
    document.addEventListener('mousemove', handleSaveLastActive);
    return () => {
      document.removeEventListener('mousemove', handleSaveLastActive);
    };
  }, [dataUser]);

  useEffect(() => {
    if (
      dataUser &&
      dataUser?.role &&
      dataUser?.role?.toLowerCase() === 'monitor'
    ) {
      return;
    }
    let intervalCheckLogout = null;
    if (maxEnableInactiveLogoutTime) {
      intervalCheckLogout = setInterval(() => {
        const now = Math.floor(new Date().getTime() / 1000);
        const lastActiveTime = localStorage.getItem(LAST_ACTIVE_TIME);
        if (now - lastActiveTime > maxEnableInactiveLogoutTime) {
          resetDataToken();
          dispatch(authLogoutThunk());
        }
      }, 3000);
    }

    return () => {
      if (intervalCheckLogout) {
        clearInterval(intervalCheckLogout);
      }
    };
  }, [dispatch, maxEnableInactiveLogoutTime, dataUser]);
};
